module.exports = __webpack_public_path__ + "static/media/r116.203a8cb9.jpg";